module.exports = __webpack_public_path__ + "static/media/edit-property.e7a25a73.png";